import React from 'react';

import PropTypes from 'prop-types';

import { Mui } from '../..';
import * as DisplayData from '../DisplayData';
import { ORDER_STATUS } from '../DisplayStatus/Order';
import Base from './Base';

function Order(props) {
  const { changes, order, ...otherProps } = props;

  const theme = Mui.useTheme();
  const fullScreen = Mui.useMediaQuery(theme.breakpoints.down('sm'));

  const skipSteps = [];
  const isInstitutionEnrollmentTuitionOrder =
    order?.sourceChannel === 'institution-contract' &&
    order?.groups?.every(group =>
      group.lines.every(line => line.product?.productClass?.toLowerCase() === 'mensalidade'),
    );
  if (isInstitutionEnrollmentTuitionOrder) {
    skipSteps.push('handling', 'invoice', 'delivered');
  }

  const STATUS_TYPES = {
    payment_approved: 'payment-approved',
    payment_denied: 'payment-denied',
    payment_pending: 'payment-pending',
    delivered: 'delivered',
    handling: 'handling',
    invoice: 'invoice',
    invoiced: 'invoiced',
    cancellation_requested: 'cancellation-requested',
    cancel: 'cancel',
  };

  const steps = changes.map(change => ({
    color: ORDER_STATUS[change.status].color,
    icon: <Mui.Icon>{ORDER_STATUS[change.status].icon}</Mui.Icon>,
    status: change.status,
    label: change.statusDisplay,
    optional: !!change.dateCreated,
    optionalLabel: <DisplayData.DateField type="datetime" value={change.dateCreated} />,
  }));

  /**
   * The usual workflow is mounted depending
   * of the last step in changes
   */
  if (steps[steps.length - 1]?.status === STATUS_TYPES.payment_denied) {
    steps.push(ORDER_STATUS[STATUS_TYPES.payment_approved]);
  }
  if (steps[steps.length - 1]?.status === STATUS_TYPES.payment_pending) {
    steps.push(ORDER_STATUS[STATUS_TYPES.payment_approved]);
  }
  if (
    steps[steps.length - 1]?.status === STATUS_TYPES.payment_approved &&
    !skipSteps?.includes?.(STATUS_TYPES.handling)
  ) {
    steps.push(ORDER_STATUS.handling);
  }
  if (
    [STATUS_TYPES.payment_approved, STATUS_TYPES.handling].includes(
      steps[steps.length - 1]?.status,
    ) &&
    !skipSteps?.includes?.(STATUS_TYPES.invoice)
  ) {
    steps.push(ORDER_STATUS.invoice);
  }
  if (
    [STATUS_TYPES.payment_approved, STATUS_TYPES.handling, STATUS_TYPES.invoice].includes(
      steps[steps.length - 1]?.status,
    ) &&
    !skipSteps?.includes?.(STATUS_TYPES.invoiced)
  ) {
    steps.push(ORDER_STATUS.invoiced);
  }
  if (
    steps[steps.length - 1]?.status === STATUS_TYPES.invoiced &&
    !skipSteps?.includes?.(STATUS_TYPES.delivered)
  ) {
    steps.push(ORDER_STATUS.delivered);
  }
  if (steps[steps.length - 1]?.status === STATUS_TYPES.cancellation_requested) {
    steps.push(ORDER_STATUS.cancel);
  }
  if (steps[steps.length - 1]?.status === STATUS_TYPES.cancel) {
    steps.push(ORDER_STATUS.canceled);
  }

  return !steps?.length ? null : (
    <Base
      steps={steps}
      alternativeLabel={!fullScreen}
      orientation={fullScreen ? 'vertical' : 'horizontal'}
      activeStep={changes.length - 1}
      {...otherProps}
    />
  );
}

Order.propTypes = {
  changes: PropTypes.array.isRequired,
  order: PropTypes.object,
};

export default Order;
